module.exports = __webpack_public_path__ + "static/media/new_message.6fde4983.mp3";